/* istanbul ignore file */
import { safeTrackEvent } from '@hm-group/frontend-utils/tracking';
import { TrackingData } from "../types";
const trackVideo = ({ brand, currency, market, touchpoint, locale, pageId, pageType, pageCategory = '', pageCategoryPath = '', videoElement, duration = 0, articleCode, event_type, event_category, }) => {
    if (!videoElement) {
        return;
    }
    let iterations = 0;
    let totalTimePlayed = 0;
    const updateTimePlayed = () => {
        if (videoElement) {
            totalTimePlayed = iterations * duration + videoElement.currentTime;
        }
    };
    const trackingData = {
        page_category: pageCategory,
        page_category_path: pageCategoryPath,
        page_id: pageId,
        page_type: pageType,
        brand_id: brand,
        region_currency: currency,
        region_locale: locale,
        region_market: market,
        session_touchpoint: touchpoint,
        event_type,
        event_label: articleCode,
        event_category,
    };
    const handleVideoPlayEvent = () => {
        updateTimePlayed();
        safeTrackEvent('link', Object.assign(Object.assign({}, trackingData), { event_id: 'Start video', event_name: 'Start video', video_played_time: totalTimePlayed.toString(), video_total_duration: duration.toString() }));
    };
    const handleVideoPauseEvent = () => {
        updateTimePlayed();
        safeTrackEvent('link', Object.assign(Object.assign({}, trackingData), { event_id: 'Pause video', event_name: 'Pause video', video_played_time: totalTimePlayed.toString(), video_total_duration: duration.toString() }));
    };
    const trackVideoComplete = () => {
        updateTimePlayed();
        safeTrackEvent('link', Object.assign(Object.assign({}, trackingData), { event_id: 'Video completed', event_name: 'Video completed', video_played_time: totalTimePlayed.toString(), video_total_duration: duration.toString() }));
    };
    const handleVideoLeavePdp = () => {
        updateTimePlayed();
        safeTrackEvent('link', Object.assign(Object.assign({}, trackingData), { event_id: 'Video leave pdp', event_name: 'Video leave pdp', video_played_time: totalTimePlayed.toString(), video_total_duration: duration.toString() }));
    };
    const handleSeekingEvent = () => {
        if (videoElement.currentTime < 0.5) {
            iterations += 1;
            updateTimePlayed();
            trackVideoComplete();
        }
    };
    videoElement.addEventListener('play', handleVideoPlayEvent);
    videoElement.addEventListener('pause', handleVideoPauseEvent);
    videoElement.addEventListener('seeking', handleSeekingEvent);
    videoElement.addEventListener('beforeunload', handleVideoLeavePdp);
};
export default trackVideo;
//# sourceMappingURL=tracking.js.map